module.exports = __webpack_public_path__ + "img/webnew-salon2-content-p5.39236d98.png";